import { FulfillmentWindowSchema } from '@occc/validation';

export const fulfillmentWindowZodSchema = FulfillmentWindowSchema;
export const fulfillmentWindowSchema = FulfillmentWindowSchema;
